import * as actions from './actions';
import reducer from './reducer';
import * as selectors from './selectors';
import namespace from './types';

export {
    actions,
    namespace,
    selectors,
};

export default {
    [namespace]: reducer,
};
